import { render, staticRenderFns } from "./MobileChips.vue?vue&type=template&id=0f274ae4&scoped=true"
import script from "./MobileChips.vue?vue&type=script&lang=js"
export * from "./MobileChips.vue?vue&type=script&lang=js"
import style0 from "./MobileChips.vue?vue&type=style&index=0&id=0f274ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f274ae4",
  null
  
)

export default component.exports